import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { CycleInventoryReportPayload } from './interfaces/cycle-inventory-report-payload.interface';

@Injectable({
  providedIn: 'root'
})
export class CycleInventoryReportService {

  private endpoint: string = `${this.apiSvc.endpoints.inventory}/api/Inventory/BarcodeCycleInventoryReport`;

  constructor(
    private apiSvc: ApiService,
  ) { }

  /**
   * Create Cycle Inventory Report
   * @param {string} contentType
   * @returns {object} httpHeaders
   */
  create(cartHeadId: number, payload: CycleInventoryReportPayload): any {
    return this.apiSvc.add(`${this.endpoint}/${cartHeadId}`, payload);
  }

}
